import "./Header.scss";
import { ReactComponent as LinkedinIcon } from "../assets/icon.linkedin.svg";
import { ReactComponent as PhoneIcon } from "../assets/icon.phone.svg";
import { ReactComponent as EmailIcon } from "../assets/icon.email.svg";
import { ReactComponent as LocationIcon } from "../assets/icon.location.svg";

function Header() {
  return (
    <header className="header">
      <div className="heading-block">
        <h1>Dmytro Uchkin</h1>

        <h2 className="job-title">Senior Software Engineer</h2>
      </div>

      <ul className="contact-list">
        <li>
          <span className="icon">
            <LocationIcon />
          </span>
          <address>London, UK</address>
        </li>

        <li>
          <a href="mailto:dmytro.uchkin@gmail.com">
            <span className="icon">
              <EmailIcon />
            </span>
            <address>dmytro.uchkin@gmail.com</address>
          </a>
        </li>

        <li>
          <a href="tel:+447397615315">
            <span className="icon">
              <PhoneIcon />
            </span>
            <address>+447397615315</address>
          </a>
        </li>

        <li>
          <a
            href="https://www.linkedin.com/in/dmytro-uchkin/"
            target="blank"
          >
            <span className="icon">
              <LinkedinIcon />
            </span>
            <address>LinkedIn</address>
          </a>
        </li>
      </ul>

      {/* <div className="tech-section">
Lorem Ipsum is simply dummy text of the printing and typesetting
industry. Lorem Ipsum has been the industry's standard dummy text
ever since the 1500s, when an unknown printer took a galley of type
and scrambled it to make a type specimen book.
</div> */}
    </header>
  );
}

export default Header;
